import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/core/authentication/auth.service';
import { Roles } from 'src/app/shared/model/Roles';

@Component({
  selector: 'app-portal-switcher',
  templateUrl: './portal-switcher.component.html',
  styleUrls: ['./portal-switcher.component.scss']
})
export class PortalSwitcherComponent implements OnInit {

  constructor(private authService: AuthService, 
    private router: Router) {
  }

  @Input() allowMainPortal = false;
  @Input() allowMobilePortal = false;
  @Input() allowWorkshopPortal = false;
  @Input() allowDealerPortal = false;
  @Input() allowCalculationPortal = false;
  @Input() allowPartsSupplierPortal = false;
  
  showMainPortal = false;
  showMobilePortal = false;
  showWorkshopPortal = false;
  showDealerPortal = false;
  showCalculationPortal = false;
  showPartsSupplierPortal = false;

  ngOnInit(): void {
    this.showMainPortal = this.allowMainPortal && this.isPortalUser();
    this.showMobilePortal = this.allowMobilePortal && this.isMobileUser();
    this.showWorkshopPortal = this.allowWorkshopPortal && this.isWorkshopPortalUser();
    this.showDealerPortal = this.allowDealerPortal && this.isDealerPortalUser();
    this.showCalculationPortal = this.allowCalculationPortal && this.isCalculationPortalUser();
    this.showPartsSupplierPortal = this.allowPartsSupplierPortal && this.isPartsSupplierPortalUser();
  }


  isMobileUser():boolean{
    return this.authService.hasRole(Roles.MobileAppUser);
  }

  isWorkshopPortalUser():boolean{
    return this.authService.hasRole(Roles.WorkshopUser);
  }

  isPortalUser():boolean{
    return this.authService.hasRole(Roles.PortalUser);
  }

   isDealerPortalUser():boolean{
    return this.authService.hasRole(Roles.DealerUser);
  }

  isCalculationPortalUser():boolean{
    return this.authService.hasRole(Roles.CalculatorUser);
  }

  isPartsSupplierPortalUser():boolean{
    return this.authService.hasRole(Roles.PartsSupplierUser);
  }

  goToMobilePortal(){
    this.router.navigate(['./mobileCenter']);
  }

  goToWorkshopPortal(){
    this.router.navigate(['./workshopCenter']);
  }

   goToDealerPortal(){
    this.router.navigate(['./dealerCenter']);
  }

  goToMainPortal(){
    this.router.navigate(['./claimsCenter']);
  }

  goToCalculationPortal(){
    this.router.navigate(['./calculationCenter']);
  }

  goToPartsSupplierPortal(){
    this.router.navigate(['./partsSupplierCenter']);
  }

}
